import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';

const AttendanceDialog = ({
  visible,
  onHide,
  selectedEmployee,
  attendanceForm,
  setAttendanceForm,
  handleMarkAttendanceSubmit
}) => {
  const footer = (
    <div>
      <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
      <Button label="Mark Attendance" icon="pi pi-check" onClick={handleMarkAttendanceSubmit} className="p-button-success" />
    </div>
  );

  return (
    <Dialog header="Mark Attendance" visible={visible} onHide={onHide} style={{ width: '500px' }} footer={footer}>
      {selectedEmployee && (
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg">
            <h4 className="font-semibold">{selectedEmployee.firstName} {selectedEmployee.lastName}</h4>
            <p className="text-gray-600">{selectedEmployee.id} - {selectedEmployee.departmentName}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Date *</label>
              <Calendar value={attendanceForm.date} onChange={(e) => setAttendanceForm({ ...attendanceForm, date: e.value })} showIcon className="w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Status *</label>
              <Dropdown value={attendanceForm.status} onChange={(e) => setAttendanceForm({ ...attendanceForm, status: e.value })} options={[{ label: 'Present', value: 'present' }, { label: 'Absent', value: 'absent' }]} className="w-full" />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Notes</label>
            <InputTextarea value={attendanceForm.notes} onChange={(e) => setAttendanceForm({ ...attendanceForm, notes: e.target.value })} rows={3} className="w-full" />
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default AttendanceDialog;
